// https://github.com/Lioydiano/Classeviva-Official-Endpoints/tree/master

const BASE_URL = "https://web.spaggiari.eu/rest/v1";
const HEADERS = {
    "User-Agent": "zorro/1.0",
    "Z-Dev-Apikey": "+zorro+",
    // "Access-Control-Allow-Origin": "http://localhost:3000",
    // "Access-Control-Allow-Credentials": "Access-Control-Allow-Credentials",
};

async function login(user) {
    try {
        const response = await fetch(`${BASE_URL}/auth/login`, {
            method: 'POST',
            headers: HEADERS,
            body: {          
                ident: null,
                pass: user.registerPassword,
                uid: user.registerUserId,
            }
        });

        return await response.json(); 
    } catch (err) {
        console.warn(`Error while logging in Classeviva: ${err}`);
        return {};
    }
}

/* 
    {
        "agenda": [
            {
                "evtId": 1866236, 
                "evtCode": "AGHW", 
                "evtDatetimeBegin": "2022-06-03T11:00:00+02:00", 
                "evtDatetimeEnd": "2022-06-03T12:00:00+02:00", 
                "isFullDay": false, 
                "notes": "P. 467 n. 210-212-223-302-304-407-418-421", 
                "authorName": "NOME COGNOME", 
                "classDesc": "2QS SCIENTIFICO - OPZIONE SCIENZE APPLICATE QUADRIENNALE", 
                "subjectId": 206168, 
                "subjectDesc": "MATEMATICA", 
                "homeworkId": null
            }
        ]
    }
*/
async function getEvents(token, studentId) {
    try {
        const response = await fetch(`${BASE_URL}/students/${studentId}/agenda/all/`, {
            headers: { ...HEADERS, token }
        });

        return (await response.json()).agenda;
    } catch (err) {
        console.warn(`Error while fetching events from Classeviva: ${err}`);
        return {};
    }
}


/* 
    {
        "subjects": [
            {
                "id": 217039,
                "description": "STORIA",
                "order": 19,
                "teachers": [
                    {
                        "teacherId": "A86047",
                        "teacherName": "COGNOME NOME"
                    },
                    {
                        "teacherId": "A5520507",
                        "teacherName": "COGNOME NOME"
                    }
                ]
            }
        ]
    }
*/
async function getSubjects(token, studentId) {
    try {
        const response = await fetch(`${BASE_URL}/students/${studentId}/subjects/`, {
            headers: { ...HEADERS, token }
        });

        return (await response.json()).subjects;
    } catch (err) {
        console.warn(`Error while fetching subjects from Classeviva: ${err}`);
        return {};
    }
}

export {
    login,
    getEvents,
    getSubjects
}